import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Header from './component/Header'
import InstitutionDetails from './pages/InstitutionDetails'
import Institution from './pages/Institution'
import Contact from './pages/Contact'
import OnlineClass from './pages/OnlineClass'
import About from './pages/About'
import Donation from './pages/Donation'
import Footer from './component/Footer'
import OurWork from './pages/OurWork'

export default function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/our-work" element={<OurWork />} />
        <Route path="/institution" element={<Institution />} />
        <Route path="/institution/:slug" element={<InstitutionDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/online-class" element={<OnlineClass />} />
      </Routes>
      <Footer />
    </>
  )
}
